document.addEventListener('DOMContentLoaded', () =>{
    let navigationDropdowns = document.querySelectorAll('.header__navigation .nav-item.dropdown');
    let header = document.querySelector('#header');
    let lastOpenedId = "";

    for (let navigationDropdown of navigationDropdowns) {
        navigationDropdown.addEventListener('show.bs.dropdown', (e) => {
            header.classList.add('dropdown-open');
            lastOpenedId = e.target.id;
        });

        navigationDropdown.addEventListener('hide.bs.dropdown', (e) => {
            if (e.target.id === lastOpenedId) {
                header.classList.remove('dropdown-open');
            }
        });
    }
});